import {
  PLAYER_SONG_SET,
  PLAYER_SONG_PAUSE,
  PLAYER_IS_SHOWN_TOGGLE,
  PLAYER_SONG_SET_IS_LOADED,
} from '../actions/PlayerActions';

function posts(
  state = {
    // todo: not sure if we're using isFetching, didInvalidate, or items...
    isFetching: false,
    didInvalidate: false,
    items: [],
    isPlaying: false,
    isLoading: false,
    currentSong: null,
  },
  action
) {
  switch (action.type) {
    case PLAYER_SONG_SET: {
      return Object.assign({}, state, {
        isFetching: true,
        isLoading: true,
        didInvalidate: false,
        currentSong: action.song,
      });
    }
    default:
      return state;
    }
}

function SongPlayerReducer(state = {
  currentSong: null,
}, action) {
  switch (action.type) {
    case PLAYER_SONG_SET_IS_LOADED: {
      return Object.assign({}, state, {
        isLoading: false,
        isPlaying: action.shouldPlay,
      });
    }
    case PLAYER_SONG_PAUSE: {
      return Object.assign({}, state, {
        isPlaying: !action.shouldPause
      });
    }
    case PLAYER_SONG_SET: {
      return Object.assign({}, state, posts(state, action));
    }
    default: {
      return state;
    }
  }
}


function ShowPlayerReducer(state = false, action) {
  switch (action.type) {
    case PLAYER_IS_SHOWN_TOGGLE: {
      return action.show;
    }
    default: {
      return state;
    }
  }
}

export {
  SongPlayerReducer,
  ShowPlayerReducer
};


// WEBPACK FOOTER //
// ./src/reducers/PlayerReducer.js